<template>
  <div class="notification-case nounderline">
    <!-- <div
      :style="{
        backgroundImage: `url('https://go.mydoc.ge/assets/imgs/symptom-knowledge-bg.jpg')`,
      }"
      class="photo d-inline-block shadow-sm"
    ></div> -->
    <div
      class="row no-gutters align-items-center position-relative overflow-hidden border-bottom"
    >
      <div class="col-auto text-primary border-right p-3 h-100">
        <div
          v-if="entity.schedule && entity.schedule.assignee && entity.schedule.assignee.photo"
          :style="{
            backgroundImage: `url(${staticUrl}${entity.schedule.assignee.photo})`,
          }"
          class="photo d-inline-block shadow-sm rounded-circle"
          :class="{
            doconline: entity.schedule.assignee && isOnline(entity.schedule.assignee.id),
          }"
        ></div>
      </div>
      <div class="col mb-2 p-3">
        <small class="text-muted" v-if="entity.schedule.assignee">

          {{ entity.schedule.assignee.firstname[authLocale] }}
          {{ entity.schedule.assignee.lastname[authLocale] }}
        </small>
        <h4 class="svg svg-upper">
          {{ $t(action) }}
        </h4>
        <small class="d-block text-muted">
          {{ entity.created_at | moment("from", "now") }}
        </small>
      </div>
    </div>
    <div class="row no-gutters align-items-center">
      <div class="col">
        <PatientCase :value="entity.id"></PatientCase>
      </div>
    </div>
  </div>
</template>
<script>
// import CaseLink from '@/components/Cases/Link'
import PatientCase from '@/components/Cases/PatientCase.vue'
import { mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    PatientCase
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authLocale: 'auth/locale',
      isOnline: 'status/isOnline'
    })
  },
  mounted () {
    this.setCase(this.entity)
  },
  methods: {
    ...mapMutations({
      setCase: 'pcase/set'
    })
  }
}
</script>
<style lang="scss">
.notification-case {
  .photo {
    width: 100%;
    padding-top: 56.25%;
    background-size: cover;
    background-position: center;
  }
  .month {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 80px;
    font-size: 0.75em;
  }
  .day {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 44px;
    font-size: 2em;
  }
  svg {
    width: 75px !important;
    // height: 100px;
  }
}
</style>
<i18n>
{
  "ka": {
      "PatientCase": "სამედიცინო ჩანაწერი",
      "PatientCaseFinished": "გამოქვეყნდა"
  },
  "en": {
      "PatientCase": "Medical Case",
      "PatientCaseFinished": "Published"
  }
}
</i18n>
